/**
 * Module dependencies.
 */

import { Breakpoints, breakpoints } from './breakpoints';
import { FlattenSimpleInterpolation, css } from 'styled-components';

/**
 * Export `CssArgs` type.
 */

export type CssArgs = FlattenSimpleInterpolation | TemplateStringsArray | [];

/**
 * `Media` type.
 */

type Media = Record<
  'max' | 'min',
  Record<
    Breakpoints,
    (
      styles: TemplateStringsArray,
      ...interpolations: CssArgs
    ) => FlattenSimpleInterpolation
  >
>;

/**
 * Render query.
 */

function renderQuery(orientation: string, value: number) {
  return (
    styles: TemplateStringsArray,
    ...interpolations: CssArgs
  ): FlattenSimpleInterpolation => css`
    @media (${orientation}: ${value}px) {
      ${css(styles, ...interpolations)}
    }
  `;
}

/**
 * Media util.
 */

export const media = Object.entries(breakpoints).reduce(
  (queries, [key, value]) => ({
    max: {
      ...queries.max,
      [key as Breakpoints]: renderQuery('max-width', value - 1)
    },
    min: {
      ...queries.min,
      [key as Breakpoints]: renderQuery('min-width', value)
    }
  }),
  {
    max: {},
    min: {}
  }
) as Media;
